//Libraries
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CookieConsent from 'components/CookieConsent';
import CustomizeCookiesDialog from 'components/CustomizeCookiesDialog';
//Components
import IntlMessages from 'components/util/IntlMessages';

//Services
import { routeToCookiePolicy } from 'services/cookies';

import type { TCookiesType } from 'types/cookies';

interface IFooterProps {
    isUserAuthenticated: boolean;
}

const Footer = ({ isUserAuthenticated }: IFooterProps) => {
    const navigate = useNavigate();

    const yearCurrent = useMemo(() => new Date().getFullYear(), []);
    const [showPolicy, setShowPolicy] = useState(false);
    const [showPrivacySettings, setShowPrivacySettings] = useState(false);
    const [policyTypeToShow, setPolicyTypeToShow] = useState<TCookiesType | null>(null);

    const showPolicyHandler = (type: TCookiesType | null = null) => {
        if (type) {
            if (!isUserAuthenticated) {
                setPolicyTypeToShow(type);
            } else {
                routeToCookiePolicy(navigate, type);
            }
        } else {
            setShowPolicy(false);
        }
    };

    useEffect(() => {
        if (policyTypeToShow) {
            setShowPolicy(true);
        } else {
            setShowPolicy(false);
        }
    }, [policyTypeToShow]);

    useEffect(() => {
        if (!showPolicy) {
            setPolicyTypeToShow(null);
        }
    }, [showPolicy]);

    return (
        <>
            <footer className="app-footer">
                <div>
                    <span>
                        &copy; <IntlMessages id="footer.copyright" values={{ year: yearCurrent }} />
                    </span>
                    <div className="footer-policy-links">
                        <span onClick={() => showPolicyHandler('use-conditions')}>
                            <IntlMessages id="footer.conditions" />
                        </span>
                        <span onClick={() => showPolicyHandler('privacy-policy')}>
                            <IntlMessages id="footer.privacyPolilicy" />
                        </span>
                        <span onClick={() => showPolicyHandler('cookies-policy')}>
                            <IntlMessages id="footer.cookiesPolicy" />
                        </span>
                        <span onClick={() => setShowPrivacySettings(true)}>
                            <IntlMessages id="footer.privacySettings" />
                        </span>
                    </div>
                </div>
            </footer>
            {showPolicy && (
                <CookieConsent type={policyTypeToShow} close={() => showPolicyHandler()} showPolicyHandler={showPolicyHandler} />
            )}
            {showPrivacySettings && <CustomizeCookiesDialog isOpen={showPrivacySettings} setIsOpen={setShowPrivacySettings} />}
        </>
    );
};

export default Footer;
